import {
  createContext,
  useContext,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";

const LoanApplicationLayoutContext = createContext({
  isRouteGateActive: true,
  setRouteGateActive: () => {},
  saveCallback: null,
  setSaveCallback: () => {},
});

export const useLoanApplicationLayout = () => {
  return useContext(LoanApplicationLayoutContext);
};

export const LoanApplicationLayoutProvider = ({ children }) => {
  const [isRouteGateActive, setIsRouteGateActive] = useState(true);
  const saveCallbackRef = useRef(null);

  const setSaveCallback = useCallback((callback) => {
    saveCallbackRef.current = callback;
  }, []);

  const saveCallback = useMemo(
    () => async () => {
      if (saveCallbackRef.current) {
        return saveCallbackRef.current();
      }
      return Promise.resolve();
    },
    []
  );

  const value = useMemo(
    () => ({
      isRouteGateActive,
      setRouteGateActive: setIsRouteGateActive,
      saveCallback,
      setSaveCallback,
    }),
    [isRouteGateActive, saveCallback, setSaveCallback]
  );

  return (
    <LoanApplicationLayoutContext.Provider value={value}>
      {children}
    </LoanApplicationLayoutContext.Provider>
  );
};

export default LoanApplicationLayoutContext;
